<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="800">
      <v-card>
        <v-card-title>
          <span class="headline mr-5">
            <v-icon class="pr-2">visibility</v-icon>
            {{ selected.description ? selected.description : selected.invoice.face_description }}
          </span>
          <v-btn absolute right depressed flat fab small @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="list-group">
          <template v-if="selected.invoice">
            <h4 class="mb-1">Common info: </h4>
            <div class="list-group-item mb-3">
              <v-layout row wrap>
                <v-flex xs12 sm6 class="pb-2">
                  <b>Created:</b> {{$moment(selected.invoice.created_at).format('DD-MM-YYYY, HH:mm')}}
                </v-flex>
                <v-flex xs12 sm6 class="pb-2">
                  <b>Period:</b> {{ selected.invoice.expiry_at ? $moment(selected.invoice.created_at).format('DD/MM/YYYY') + ' - ' + $moment(selected.invoice.expiry_at).format('DD/MM/YYYY') : '&nbsp; -' }}
                </v-flex>
                <v-flex xs12 sm6 class="pb-2">
                  <b>Status:</b> {{selected.invoice.invoice_status}}
                </v-flex>
                <v-flex xs12 sm6 class="pb-2">
                  <b>Status Desc:</b> {{selected.invoice.response_desc ? selected.invoice.response_desc : '&nbsp; -'}}
                </v-flex>
                <v-flex xs12 sm6 class="pb-2">
                  <b>Internal deal number:</b> {{ selected.invoice.internal_deal_number || '&nbsp; -'}}
                </v-flex>
                <v-flex xs12 sm6 class="pb-2">
                  <b>First card digits:</b> {{ selected.invoice.first_card_digits || '&nbsp; -'}}
                </v-flex>
                <v-flex xs12 sm12>
                  <b>Total:</b> {{selected.invoice.purchase_sum}} {{currencySign[selected.invoice.currency]}}
                </v-flex>
              </v-layout>
            </div>
          </template>
          <!-- <v-data-table
            :headers="headers"
            :items="selected.details"
            hide-actions
            class="no-action-table history-details-table"
          >
            <template slot="items" slot-scope="props">
              <td>
                {{ props.item.product_name ? props.item.product_name : '-' }}
              </td>
              <td class="text-xs-center">
                {{props.item.quantity}}
              </td>
              <td class="text-xs-center">
                {{props.item.price}}{{currencySign[selected.currency]}}
              </td>
            </template>
          </v-data-table> -->
          <template v-if="selected.invoice && selected.invoice.details.length">
            <h4 class="mb-1">Products: </h4>
            <div class="list-group-item" v-for="(item, index) in selected.invoice.details" :key="'product_' + index">
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  Name: {{item.product_name}}
                </v-flex>
                <v-flex xs12 sm3>
                  Quantity: {{item.quantity}}
                </v-flex>
                <v-flex xs12 sm3>
                  Price: {{ Number(item.price.toFixed(2)) }}&nbsp;{{ currencySign[selected.invoice.currency] }}
                </v-flex>
              </v-layout>
            </div>
          </template>
          <template v-if="selected.invoice && selected.invoice.discounts.length">
            <h4 class="mb-1 mt-4">Discounts: </h4>
            <div class="list-group-item" v-for="discount in selected.invoice.discounts" :key="'discount_' + discount.id">
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  Discount: {{discount.percentage}}%
                </v-flex>
                <v-flex xs12 sm3>
                  Product: {{ discount.product_display_name ? discount.product_display_name : 'all'}}
                </v-flex>
                <v-flex xs12 sm3>
                  Source:
                  <span v-if="discount.source === $store.state.discount.sources.COUPON">
                    Coupon
                    <router-link v-if="isAdmin" class="simple-link" :to="{ name: 'Coupons', query: { search: discount.source_coupon_name }}"> <span>{{ discount.source_coupon_name }}</span></router-link>
                    <span v-else>{{ discount.source_coupon_name }}</span>
                  </span>
                  <span v-else>Admin</span>
                </v-flex>
              </v-layout>
            </div>
          </template>
          <template v-if="selected.transactions && selected.transactions.length">
            <h4 class="mb-1 mt-3">Transactions: </h4>
            <div class="list-group-item" v-for="item in selected.transactions" :key="item.id">
              <v-layout row wrap>
                <v-flex xs12 sm7 class="pr-1">
                  {{item.op_desc.split('. ')[0]}}
                </v-flex>
                <v-flex xs12 sm3 class="pr-1">
                  {{item.op_desc.split('. ')[1]}}
                </v-flex>
                <v-flex xs12 sm2>
                  {{Number((item.amount).toFixed(2))}}&nbsp;{{currencySign[item.currency_id]}}
                </v-flex>
                <!-- <v-flex xs12 sm3>
                  Price: {{item.price}}{{currencySign[selected.invoice.currency]}}
                </v-flex> -->
              </v-layout>
            </div>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'HistoryDetailsModal',
  props: ['invoiceDialog', 'selected'],
  data () {
    return {
      dialog: this.invoiceDialog,
      isAdmin: this.$store.state.user.permissions.is_admin,
      headers: [
        { text: 'Name', value: 'product_name', sortable: false },
        { text: 'Quantity', value: 'quantity', sortable: false, align: 'middle' },
        { text: 'Price', value: 'price', sortable: false, align: 'middle' }
      ],
      currencySign: {
        DOLLARS: '$',
        USD: '$',
        NIS: '₪'
      }
    }
  },
  mounted () {
  },
  watch: {
    invoiceDialog: {
      handler () {
        this.dialog = this.invoiceDialog
        if (this.dialog && !this.selected) {
          this.clearForm()
        }
      }
    },
    dialog: {
      handler () {
        this.$parent.$emit('invoiceDialog', this.dialog)
      }
    },
    selected: {
      handler () {
      }
    }
  },
  methods: {
    closeModal () {
      this.dialog = false
      // this.clearForm()
    }
  }
}
</script>

<style scoped>
.list-group-item {
    position: relative;
    display: block;
    padding: .75rem 1.25rem;
    margin-bottom: -1px;
    background-color: #fff;
    border: 1px solid rgba(0,0,0,.125);
}
.list-group-item:first-child {
    border-top-left-radius: .25rem;
    border-top-right-radius: .25rem;
}
.list-group-item .flex {
  margin: auto;
}
.list-group {
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    -ms-flex-direction: column;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    flex-direction: column;
    margin-bottom: 0;
    min-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/subscriptions/HistoryDetailsModal.vue